<app-loading *ngIf="isLoading"></app-loading>
<div *ngIf="!isLoading">
  <div class="compare-group-header">
    <h1>List of available Benchmarks:</h1>
    <mat-form-field>
      <mat-label>Select an organization</mat-label>
      <mat-select [(ngModel)]="selectedOrg" (selectionChange)="changeOrg($event)">
        <mat-option *ngFor="let org of orgIDs" [value]="org.orgId" [title]="org.orgName">
          {{org.orgName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="compare-list-container">

    <h3>{{currentOrgName}}</h3>
    <div class="compare-list-header">
      <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search..." appearance="outline">
        <button mat-button matPrefix><mat-icon class="search-hourglass">search</mat-icon></button>
      </mat-form-field>
      <button mat-stroked-button color="primary" class="first-button" (click)="createCompareGroup()">+ Add Benchmark</button>
    </div>

    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef>Edit</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [disabled]="row.compareGroupId <= 0" (click)="editCompareGroup(row.compareGroupId)">
            <mat-icon [ngClass]="{'pointer': row.compareGroupId > 0}" mat-list-icon title="Edit" >edit</mat-icon>
          </button>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef>Delete</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [disabled]="row.compareGroupId <= 0" (click)="deleteCompareGroup(row.compareGroupId, row.compareGroupDesc)">
            <mat-icon [ngClass]="{'pointer': row.compareGroupId > 0}" mat-list-icon title="Delete">delete</mat-icon>
          </button>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="compareGroupDesc">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let row"> {{row.compareGroupDesc}}</td>
      </ng-container>
      
      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
        <td mat-cell *matCellDef="let row"> {{row.createdBy}}</td>
      </ng-container>
      
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let row"> {{row.createdOn | date:'MM/dd/yyyy, h:mm a'}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <app-no-data *ngIf="isGroupEmpty" noDataTitle="There are no data to show" noDataSubTitle="There are no compare groups for your selected organization"></app-no-data>
    <app-alert *ngIf="showAlert" header="Notice" message="{{alertMessage}}" (closeAlert)="closeAlert()" [confirm]="alertIsConfirm" (alertConfirm)="alertConfirm($event)"></app-alert>
  </div>
</div>